import '.ah{flex-shrink:0;}.ssr-plugin'
import '.ac{padding:1rem;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.ai{height:100%;}.ssr-plugin'
import '.ck{border:none;}.ssr-plugin'
import '.cn{background-color:transparent;}.ssr-plugin'
import '.co{border-radius:0px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.x{align-items:stretch;}.ssr-plugin'
import '.b8{position:sticky;}.ssr-plugin'
import '.cp{top:4rem;}.ssr-plugin'
import '.cq{z-index:7;}.ssr-plugin'
import '.a1{background-color:var(--palette-white);}.ssr-plugin'
import '.cr{padding-bottom:1rem;}.ssr-plugin'
import '.cs{margin-bottom:1rem;}.ssr-plugin'
import '.ct{border-bottom:var(--border-subtle);}.ssr-plugin'
import '.i{position:fixed;}.ssr-plugin'
import '.b9{top:0px;}.ssr-plugin'
import '.be{left:0px;}.ssr-plugin'
import '.bf{right:0px;}.ssr-plugin'
import '.bg{bottom:0px;}.ssr-plugin'
import '.cu{z-index:9999;}.ssr-plugin'
import '.cv{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.b7{justify-content:flex-end;}.ssr-plugin'
import '.aj{flex:1;}.ssr-plugin'
import '.bq{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { TextLink } from '@app/components/core/link/TextLink'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="ah ac n ai ck cn co"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="d e x"
    >
      <div className="b8 cp cq a1 cr cs ct d"
      >
        <TextLink onClick={() => setIsOpen(true)}>{collapsedButtonLabel}</TextLink>
      </div>

      <div className="i b9 be bf bg cu a1 cv d e"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="ac d b7 ct"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="aj bq">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
